import { render } from "./DeleteFromArea.vue?vue&type=template&id=9435e85a"
import script from "./DeleteFromArea.vue?vue&type=script&lang=js"
export * from "./DeleteFromArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__